import { render, staticRenderFns } from "./PushConfigRegister.vue?vue&type=template&id=048250c6"
import script from "./PushConfigRegister.vue?vue&type=script&lang=js"
export * from "./PushConfigRegister.vue?vue&type=script&lang=js"
import style0 from "./PushConfigRegister.vue?vue&type=style&index=0&id=048250c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports